<div class="cupping-editor">
  <div class="details-container">
    <div class="scoring-section">
      <rms-mod>
        <div>
          <div style="display:flex; gap:10px; align-items:center">
            <h3>SCA Total: {{CuppingSessionDetails.SCAATotal}}</h3>
            <button mat-icon-button [matMenuTriggerFor]="InfoMenu"><mat-icon>info</mat-icon></button>
          </div>
          <rms-data-slider label="Acidity" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="CuppingSessionDetails.Acidity" (ngModelChange)="onUpdated()"></rms-data-slider>
          <rms-data-slider label="Body" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="CuppingSessionDetails.Body" (ngModelChange)="onUpdated()"></rms-data-slider>
          <rms-data-slider label="Sweetness" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="CuppingSessionDetails.Sweetness" (ngModelChange)="onUpdated()"></rms-data-slider>
          <rms-data-slider label="Aftertaste" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="CuppingSessionDetails.Aftertaste" (ngModelChange)="onUpdated()"></rms-data-slider>

          <rms-data-slider label="Overall"
                           [step]="0.25"
                           [min]="6"
                           [max]="10"
                           [(ngModel)]="CuppingSessionDetails.Overall"
                           (ngModelChange)="onUpdated()"></rms-data-slider>
        </div>
        <mat-menu #InfoMenu="matMenu" [class]="'custom-menu'">

          <div class="scaa-breakdown-menu" (click)="$event.stopPropagation()">

            <div class="scaa-menu-header">
              <div>
                <div class="scaa-menu-title">SCA Total Breakdown</div>
                <div class="scaa-menu-subtitle">
                  Live calculation based on current slider values
                </div>
              </div>

              <div class="scaa-total-pill">
                {{ CuppingSessionDetails.SCAATotal ?? 0 }}
              </div>
            </div>

            <div class="scaa-formula-box">
              <div class="formula-label">Formula</div>

              <div class="formula-text">
                (((Acidity + Body + Sweetness + Aftertaste + Overall) / 5) × 7) + 30
              </div>

              <div class="formula-note">
                The extra <strong>30 points</strong> comes from 3 defaulted categories scored at
                <strong>10 points each</strong>.
              </div>
            </div>

            <div class="scaa-live-grid">
              <div class="score-card">
                <span class="score-label">Acidity</span>
                <span class="score-value">{{ CuppingSessionDetails.Acidity ?? 0 }}</span>
              </div>

              <div class="score-card">
                <span class="score-label">Body</span>
                <span class="score-value">{{ CuppingSessionDetails.Body ?? 0 }}</span>
              </div>

              <div class="score-card">
                <span class="score-label">Sweetness</span>
                <span class="score-value">{{ CuppingSessionDetails.Sweetness ?? 0 }}</span>
              </div>

              <div class="score-card">
                <span class="score-label">Aftertaste</span>
                <span class="score-value">{{ CuppingSessionDetails.Aftertaste ?? 0 }}</span>
              </div>

              <div class="score-card">
                <span class="score-label">Overall</span>
                <span class="score-value">{{ CuppingSessionDetails.Overall ?? 0 }}</span>
              </div>
            </div>

            <div class="scaa-calculation-stack">
              <div class="calc-row">
                <span>Slider Score Sum</span>
                <strong>{{ scaaSliderSum }}</strong>
              </div>

              <div class="calc-row">
                <span>Average Slider Score</span>
                <strong>{{ scaaSliderAverage }}</strong>
              </div>

              <div class="calc-row">
                <span>Average × 7</span>
                <strong>{{ scaaWeightedScore }}</strong>
              </div>

              <div class="calc-row default-row">
                <span>Defaulted Scores</span>
                <strong>+ {{ scaaDefaultScore }}</strong>
              </div>

              <div class="calc-row total-row">
                <span>Final SCA Total</span>
                <strong>{{ scaaLiveTotal }}</strong>
              </div>
            </div>

            <div class="default-score-section">
              <div class="default-score-title">Defaulted Categories</div>

              <div class="default-score-list">
                <div class="default-score-card">
                  <span>Uniformity</span>
                  <strong>10</strong>
                </div>

                <div class="default-score-card">
                  <span>Clean Cup</span>
                  <strong>10</strong>
                </div>

                <div class="default-score-card">
                  <span>Sweetness</span>
                  <strong>10</strong>
                </div>
              </div>
            </div>

          </div>

        </mat-menu>
      </rms-mod>
    </div>
    <div class="right-side-container">
      <div class="flavor-notes">
        @for(flavorNote of AllFlavorNotes; track $index){
        <button type="button" class="flavor-note-card" (click)="toggleFlavorNote(flavorNote)" [class.selected]="flavorNote.selected" [attr.aria-pressed]="!!flavorNote.selected" [attr.aria-label]="flavorNote.labelName">


          <div class="flavor-note-number" *ngIf="flavorNote.order">
            {{ flavorNote.order }}
          </div>


          <img src="{{ flavorNote.url }}" alt="{{ flavorNote.name }}">
          <div class="flavor-note-text">{{flavorNote.labelName}}</div>
        </button>
        }
      </div>
      <div class="additional-notes">
        <fieldset class="rms-fieldset" style="width:60%">
          <legend>Defective Cups</legend>
          <div style="width:100%; display:flex; gap:20px">
            <div style="width:25%"><rms-number label="Mold" [(ngModel)]="CuppingSessionDetails.Mold" (ngModelChange)="onUpdated()"></rms-number></div>
            <div style="width:25%"><rms-number label="Phenol" [(ngModel)]="CuppingSessionDetails.Phenol" (ngModelChange)="onUpdated()"></rms-number></div>
            <div style="width:25%"><rms-number label="Ferment" [(ngModel)]="CuppingSessionDetails.Ferment" (ngModelChange)="onUpdated()"></rms-number></div>
            <div style="width:25%"><rms-number label="Potato" [(ngModel)]="CuppingSessionDetails.Potato" (ngModelChange)="onUpdated()"></rms-number></div>
          </div>
        </fieldset>
        <rms-textarea style="width:30%" [(ngModel)]="CuppingSessionDetails.CuppingNotes" label="Cupping notes / rejection reason" (ngModelChange)="onUpdated()"></rms-textarea>
      </div>
    </div>
  </div>
    <div class="cupping-editor-actions">
      @if(rejectionReasonRequired && !CuppingSessionDetails.CuppingNotes?.trim()){<span role="alert" class="validation-message">Enter a reason in the cupping notes before rejecting.</span>}
      <button mat-button class="btn-bg-blue" (click)="cancel()">Cancel</button>
      <button mat-button class="btn-bg-red" (click)="onRejectSample()">Reject</button>
      <button mat-button class="btn-bg-yellow" (click)="onRecupSample()">Recup</button>
      <button mat-button class="btn-bg-green" (click)="onApproveSample()">Approve</button>
    </div>
</div>
